import useTranslate from "hooks/useTranslate";
import "./styles.sass";

const LoyaltyRankCardWelcome: React.FC = () => {
  const t = useTranslate();
  return (
    <div className="LoyaltyRankCardWelcome">
      <h1 className="LoyaltyRankCardWelcome__title">
        {t("loyalty.block1.title")}
      </h1>
    </div>
  );
};

export default LoyaltyRankCardWelcome;
